import styled from 'styled-components';
import { CommonPageWrapper, HeadingWrapper } from 'admin/components/wrappers';
import AdminDropDown from 'app/components/AdminDropDown';
import { AdminSearch } from 'app/components/AdminSearchField';
import CustomBreadCrumb from 'app/components/CustomBreadCrumb';
import { PageMainLabel } from 'app/components/SHLabel';
import { useDebounce } from 'hooks/useDebounce';
import { useState } from 'react';
import { GeneralLookup } from 'services/openapi';
import { usePermission } from 'hooks/usePermission';
import CoachInsuranceTable from './CoachInsurenceTable';
import useCoachApi from 'admin/hooks/useCoachApi';

const CoachInsuranceReport = () => {
  const breadCrumbItems = [
    {
      id: '',
      text: 'Showyeda admin',
      disabled: true,
    },
    {
      id: '',
      text: 'Coach Insurance Report',
      disabled: true,
    },
  ];
  const { hasViewPermission } = usePermission();

  const {
    loading,
    fetchCoachInsuranceList,
    coachInsuranceListData,
    generatePdf,
    getGeneratedPdf,
    uploadInsurancePdf,
    sendMailtoInsurer,
  } = useCoachApi();

  const [searchTerm, setSearchTerm] = useState<string>('');
  const [pageSkip, setPageSkip] = useState<number | undefined>(0);
  const [pageSize, setPageSize] = useState<number>(50);
  const [pageSizeSelected, setPageSizeSelected] = useState<GeneralLookup>({
    id: '50',
    name: '50',
  });

  // Page size options for the dropdown
  const pageSizeOptions: GeneralLookup[] = [
    { id: '25', name: '25' },
    { id: '50', name: '50' },
    { id: '100', name: '100' },
    { id: '200', name: '200' },
  ];
  const debounceShowSearch = useDebounce(searchTerm);

  const [sortField, setSortField] = useState<string | undefined>(undefined);
  const [sortOrder, setSortOrder] = useState<number | undefined>(0);
  const [isOrder, setIsOrder] = useState(false);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const handlePageSizeChange = (data: GeneralLookup) => {
    const newPageSize = parseInt(data.id, 10);
    setPageSize(newPageSize);
    setPageSizeSelected(data);
    setPageSkip(0);
    fetchCoachInsuranceList(
      '',
      debounceShowSearch, // searchInput
      pageSkip, // pageNumber
      newPageSize, // pageSize
    );
  };

  return (
    <>
      <CommonPageWrapper>
        <HeadingWrapper>
          <PageMainLabel>Coach Insurance Report</PageMainLabel>
          <CustomBreadCrumb preData={breadCrumbItems} />
        </HeadingWrapper>

        {coachInsuranceListData && (
          <EntriesPerPageDropDownWrapper>
            <AdminDropDown
              label="No: of entries per page"
              placeholder="Select entries"
              onDataChange={(data: GeneralLookup) => {
                const newPageSize = parseInt(data.id, 10);
                setPageSize(newPageSize);
                setPageSizeSelected(data);
                handlePageSizeChange(data);
              }}
              defaultValue={pageSizeSelected}
              data={pageSizeOptions}
              className="entries-dropdown-style"
              popupStyles="entries-dropdown-popup"
            />
            <HeadingWrapper>
              <FilterContainer>
                <SearchWrapper>
                  <AdminSearch
                    placeholder="Search by name"
                    onSearchTextEntering={handleSearch}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                  />
                </SearchWrapper>
              </FilterContainer>
            </HeadingWrapper>
          </EntriesPerPageDropDownWrapper>
        )}
        {/* Shows Table */}
        {hasViewPermission('1200101005') && (
          <CoachInsuranceTable
            setPageSkip={setPageSkip}
            pageSkip={pageSkip}
            pageSize={pageSize}
            debounceShowSearch={debounceShowSearch}
            fetchCoachInsuranceList={fetchCoachInsuranceList}
            coachInsuranceData={coachInsuranceListData}
            sortField={sortField}
            sortOrder={sortOrder}
            setSortField={setSortField}
            setSortOrder={setSortOrder}
            setIsOrder={setIsOrder}
            isOrder={isOrder}
            loading={loading}
            pageSizeSelected={pageSizeSelected}
            generatePdf={generatePdf}
            getGeneratedPdf={getGeneratedPdf}
            uploadInsurancePdf={uploadInsurancePdf}
            sendMailtoInsurer={sendMailtoInsurer}
          />
        )}
      </CommonPageWrapper>
    </>
  );
};

export default CoachInsuranceReport;

const FilterContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 20px;
  flex-wrap: wrap;
  width: 100%;
  .custom-calendar-wrapper {
    min-height: unset !important;
  }
  .k-input-solid {
    height: 33px !important;
  }
`;

const SearchWrapper = styled.div`
  flex: 1;
  min-width: 250px;
  max-width: 300px;
`;
const EntriesPerPageDropDownWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
  .SHdropdown {
    width: 160px;

    .label {
      margin-bottom: 8px;
      font-size: 13px;
      color: #475467;
      font-weight: 500;
    }

    .k-dropdownlist {
      max-height: 38px;
      border-radius: 8px !important;
    }

    .k-input-inner {
      padding: 0 8px !important;
      font-size: 13px;
    }

    .k-input-value-text {
      margin: 4px 0;
      font-size: 13px !important;
      color: #1e1e1e;
    }
  }
`;
